export default __webpack_public_path__ + "static/media/logo1.33414a0a.png";